<template>
  <div style="height:960px;">
    <h2>关于页面</h2>

  </div>
</template>

<script>
export default {
  name: 'About',
};
</script>
